// Vendor packages
import Vue from 'vue';
import VueRouter from 'vue-router';
import { store } from '../store';
import routes from './routes';

Vue.use(VueRouter);

export const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

/**
 * Before each route navigation, check if the user location is set 
 * if not redirect to the location page and then allow the user to 
 * set it else, continue the normal next route.
 *
 * Also before each route navigation, show the app loader
 */
router.beforeEach((to, from, next) => {	
  	store.dispatch('showLoader');

  	let isUserLocationSet = store.getters['User/isLocationSet'];

  	if (!isUserLocationSet && to.name.toLowerCase() !== 'location') {
  		store.dispatch('setPageTitle', 'Location');
  		next({ name: 'location' });
  	}
	
	store.dispatch('setPageTitle', to.name.replace('_', ' ').toTitleCase());
	next();
 });

/**
 * After each route navigation, hide the app loader
 */
router.afterEach((to, from) => {
	store.dispatch('hideLoader');
  store.dispatch('hideMobileNav');
});


// WEBPACK FOOTER //
// ./src/router/index.js